<template>
	<section class="marketing-section">
		<h2 class="heading-1 text-align-center mb-250"> Fund features </h2>
		<MarketingSiteCardRow
			class="ocf-fund-features-cards"
			title-size="heading-6"
			description-size="body-md"
			:cards="cards"
			theme="light"
		/>
	</section>
</template>

<script setup lang="ts">
import { MarketingSiteCard } from 'types/marketing-site';
import MarketingSiteCardRow from '@components/marketing-site/marketing-site-card-row.vue';

interface Props {
	cards: Array<MarketingSiteCard>;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;

.ocf-fund-features-cards {
	&.row {
		max-width: 800px;
		margin: auto;
		gap: 3rem 5rem;

		@include respond-to(smo) {
			gap: unset;
		}
	}

	&.row .col {
		flex: 1 1 calc(50% - 2rem);

		@include respond-to(smo) {
			flex: 0 0 100%;
			max-width: 100%;
		}
	}
}
</style>
